import SignUp from "./sign-up.page";

export default SignUp;
